import React, { useState, useEffect } from 'react';
import { format, addMonths } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import logo from "../../../assets/logo.png";
import { useSelector, useDispatch } from "react-redux";
import { userRole, userAccount } from "../../../store/auth/selector";
import { RootState } from "../../../store/config/types";
import { Menu, MenuItem, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { logout } from "../../../store/auth/actionCreators";
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';
import request from 'request';
import { BASE_URL_FOODS } from '../../../services/config';
import { PaymentStatus } from '../../../store/config/enums';

interface TurnoDia {
  __IMTKEY__: string; 
  array: {
    time: string;    // "2025-03-10T13:00:00.000Z"
    slots: number;
  }[];
}

const TurnosList: React.FC<{ turnos: TurnoDia[] }> = ({ turnos }) => {
  return (
    <div className="turnos-container">
      <div>
        <h3 style={{ color: '#6c63ff' }}>Próximos turnos disponibles</h3>
      </div>
      {turnos && turnos.length > 0 ? (
        turnos.map((dayObj) => {
          // dayObj.__IMTKEY__ => "2025-03-10T03:00:00.000Z"
          const dayFormatted = new Intl.DateTimeFormat('es-UY', {
            day: '2-digit',
            month: '2-digit',
            timeZone: 'America/Montevideo'
          }).format(new Date(dayObj.__IMTKEY__));

          return (
            <div key={dayObj.__IMTKEY__} className="turno-day" style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '5px 0px' }}>
              <h2 style={{
                padding: '10px 15px',
                backgroundColor: 'skyblue',
                borderRadius: '12px',
                width: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
              }}>{dayFormatted}</h2>
              <div className="turno-horarios" style={{ display: 'flex', width: '100%', justifyContent: 'flex-start', gap: '7px', paddingLeft: '20px' }}>
                {dayObj.array.map((slot) => {
                  const timeFormatted = new Intl.DateTimeFormat('es-UY', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                    timeZone: 'America/Montevideo'
                  }).format(new Date(slot.time));

                  return (
                    <div id={slot.time} className='turno-button'
                      style={{
                        backgroundColor: '#ffffff',
                        padding: '10px 13px',
                        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
                        borderRadius: '12px',
                        fontWeight: 'bold'
                      }}
                    >
                      {timeFormatted}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })
      ) : (
        <p>En este momento no podemos cargar el calendario de turnos.</p>
      )}
    </div>
  );
};

const ConsultaNutricional: React.FC = () => {
  const dispatch = useDispatch();
  const role = useSelector((state: RootState) => userRole(state));
  const actualUser = useSelector((state: RootState) => userAccount(state));
  const isFinalUser = role === 'user';
  const isNutritionist = role === 'nutricionist';
  const firstName = actualUser && actualUser.profile.firstName;
  const hasAnalysis = actualUser && actualUser.profile.analysis;
  const [formData, setFormData] = useState({
    name: '',
    lastName: '', // Agregado para el apellido
    email: '',
    phone: '',
  });
  
  const [consultaSeleccionada, setConsultaSeleccionada] = useState('');
  const [preference, setPreference] = useState('');
  
  const [turnos, setTurnos] = useState<any[]>([]);
  const [turnosLoading, setTurnosLoading] = useState(true); // Estado para cargar turnos

  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentStatus = queryParams.get('status');
  const [statusMP, setStatusMP] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [preferenceId, setPreferenceId] = useState('');
  // Estado para controlar el popup de datos para usuarios no logueados
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    // Si existe usuario actual, se setean los datos
    if (actualUser) {
      setFormData({
        name: actualUser?.profile?.firstName || '',
        lastName: actualUser?.profile?.lastName || '',
        email: actualUser?.email || '',
        phone: actualUser?.profile?.mobile || '',
      }); 
    }
    setConsultaSeleccionada('consultaPuntual');
  }, [actualUser]);

  useEffect(() => {
    console.log("payment-status", paymentStatus);
    if (paymentStatus !== "" && paymentStatus !== null) {
      if(queryParams.get('payment_id') === 'null') return;
      setStatusMP(paymentStatus);
      setPaymentId(queryParams.get('payment_id'));
    }
  }, [paymentStatus]);

  useEffect(() => {
    // Inicialización de MercadoPago
    initMercadoPago('APP_USR-097c1049-0ad3-4548-b85e-ba982fe5f695');
  }, []);

  useEffect(() => {
    if (consultaSeleccionada) {
      const tipoConsulta = '71184913';
      const MAX_MESES_A_CONSULTAR = 3;
  
      const consultarTurnos = (fecha, intento = 0) => {
        if (intento >= MAX_MESES_A_CONSULTAR) {
          // Límite alcanzado, mostramos que no hay disponibilidad
          setTurnos([]);
          setTurnosLoading(false);
          console.warn('No se encontraron turnos disponibles en los próximos meses.');
          return;
        }
  
        setTurnosLoading(true);
        const mes = format(fecha, 'yyyy-MM');
  
        request.post(
          'https://hook.us2.make.com/dqq7kjqa32r4n0wi93a0uy7sika7lfpw',
          { json: { tipo_consulta: tipoConsulta, mes: mes } },
          (error, response, body) => {
            setTurnosLoading(false);
            if (!error && response.statusCode === 200) {
              console.log(`Turnos recibidos para ${mes}:`, body);
              if (Array.isArray(body) && body.length === 0) {
                // No hay turnos, intento el siguiente mes
                const siguienteMes = addMonths(fecha, 1);
                consultarTurnos(siguienteMes, intento + 1);
              } else if (Array.isArray(body)) {
                setTurnos(body);
              } else {
                // Si el body no es un array, setear turnos como array vacío
                console.warn('El body no es un array:', body);
                setTurnos([]);
              }
            } else {
              console.error('Error al obtener turnos:', error || body);
              setTurnos([]); // Aseguramos siempre un array
            }
          }
        );
      };
  
      consultarTurnos(new Date());
      console.log('consulta seleccionada', consultaSeleccionada);
    }
  }, [consultaSeleccionada]);
  

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const selectOption = (option: number) => {
    if (option === 0) history.push("/profile");
    if (option === 1) {
      dispatch(logout());
      history.push("/");
    }
    if (option === 2) {
      history.push("/platos-semanales");
    }
    if(option === 3) {
      history.push("/consulta-nutricional");
    }
    setAnchorEl(null);
  };

  const handleConsultaSelection = (consulta) => {
    if(consulta === consultaSeleccionada) return;
    setPreference('');
    setConsultaSeleccionada(consulta);
  };

  // Función para generar la preferencia de pago
  const generarPreferencia = (userData: typeof formData) => {
    setIsLoading(true); // Muestra el spinner en el botón
    const orderData = {
      tipoConsulta: consultaSeleccionada,
      user: {
        name: userData.name,
        lastName: userData.lastName,
        email: userData.email,
        phone: userData.phone,
      },
    };
    const mrgenToken = {
      token: localStorage.getItem('token') || ''
    };

    request.post(
      `${BASE_URL_FOODS}/v1/payment/create_preference_hire_nutritionist`,
      {
        json: { orderData, mrgenToken },
      },
      (error, response, body) => {
        setIsLoading(false); // Oculta el spinner
        if (!error && response.statusCode === 200) {
          setPreference(body.id); // Muestra el botón de MercadoPago
        } else {
          console.error('Error al generar preferencia:', error || body);
          alert('Ocurrió un error, intenta nuevamente.');
        }
      }
    );
  };

  // Maneja el click en "Contratar"
  const handleCheckout = () => {
    // Si el usuario no está logueado, se abre el popup
    if (!actualUser) {
      setOpenPopup(true);
      return;
    }
    generarPreferencia(formData);
  };

  // Se ejecuta al enviar el formulario del popup
  const handlePopupSubmit = () => {
    if (!formData.name || !formData.lastName || !formData.email || !formData.phone) {
      alert("Por favor completa todos los campos");
      return;
    }
    setOpenPopup(false);
    generarPreferencia(formData);
  };

  const handleNavigation = () => {
    if (!window.localStorage.token) {
      history.push('/');
    } else if (!hasAnalysis) {
      history.push('/loadingPayment');
    } else {
      history.push('/dashboard');
    }
  };

  return (
    <div className="menu-semanal">
      <div className="logo-week-cart-header">
        <div className="meals-logo-header">
          <img
            style={{ width: '160px' }}
            src={logo}
            alt="logo"
            className="logo"
            onClick={handleNavigation}
          />
          <div className="cart-icon-container">
            {actualUser && (
              <div className="profile-div" onClick={handleClick}>
                <div className="image">{firstName ? firstName[0] : ''}</div>
                <span>{firstName}</span>
              </div>
            )}
          </div>
          {actualUser && (
            <Menu
              keepMounted
              anchorEl={anchorEl}
              anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
              transformOrigin={{ horizontal: "left", vertical: "top" }}
              getContentAnchorEl={null}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => selectOption(0)}>Editar perfil</MenuItem>
              <MenuItem onClick={() => selectOption(2)}>Platos semanales</MenuItem>
              <MenuItem onClick={() => selectOption(3)}>Consulta nutricional</MenuItem>
              <MenuItem onClick={() => selectOption(1)}>Cerrar sesión</MenuItem>
            </Menu>
          )}
        </div>
        <div className="week-cart consulta-cart">
          <div className="btn-consulta-container">
            <Button className="btn-consulta" variant="contained" color="primary" size="large" onClick={() => handleConsultaSelection('consultaPuntual')}>
              Consulta Inicial
            </Button>
            <Button className="btn-consulta" variant="contained" color="primary" size="large" onClick={() => handleConsultaSelection('consultaPlus4')}>
              Consulta + Plan + 2 Controles
            </Button>
            <Button className="btn-consulta" variant="contained" color="primary" size="large" onClick={() => handleConsultaSelection('consultaPlus8')}>
              Consulta + Plan + 6 Controles
            </Button>
            <Button className="btn-consulta" variant="contained" color="primary" size="large" onClick={() => handleConsultaSelection('controlesx2')}>
              2 Controles de seguimiento
            </Button>
          </div>
        </div> 
      </div>
      {statusMP && (
        <div className="container-consulta-content">
          <h1 className="ccc-title">Pago completado</h1>
          <br/><br/>
          <span><b>¡Gracias por tu compra! A la brevedad recibirás un email para agendar tu consulta</b></span>
          <br/>
          <span><b>Estado:</b> {statusMP === 'approved' ? "Aprobado" : statusMP}</span>
          <span><b>Id de pago:</b> {paymentId}</span>
        </div>
      )}
      {consultaSeleccionada === 'consultaPuntual' && !statusMP ? (
        <div className="container-consulta-content">
          <h1 className="ccc-title">Análisis Nutricional del Test Nutrigenético</h1>
          <div className="analysis-plus-container">
            <div className="image-container">
              <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906806/mistergen/landing-nutritionists-image_ltu9y3.png" alt="Consulta nutricional" />
              {/* Sección de turnos debajo de la foto */}
              {turnosLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <CircularProgress />
                </div>
              ) : (
                <TurnosList turnos={turnos} />
              )}
            </div>
            <div className="content-container">
              <p>
                En esta sesión inicial, te ayudaremos a interpretar los resultados del informe de tu test nutrigenético para optimizar tus hábitos alimenticios.
              </p>
              <p><b>Incluye:</b></p>
              <ul>
                <li><b className="pink-color">- Lectura y análisis del test nutrigenético.</b></li>
                <li>- Consulta virtual de 30 minutos.</li>
                <li>- Recomendaciones en función de los resultados.</li>
              </ul>
              <div className="price-container">
                <p className="price-total">Precio total</p>
                <p className="price-amount">$U 2.000 <span className="tax-included">Impuestos incluidos</span></p>
              </div>
              {!preference ? (
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="large" 
                  style={{ margin: '0px 40px', width: '100%' }}
                  onClick={handleCheckout}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Contratar"}
                </Button>
              ) : (
                <Wallet 
                  initialization={{ preferenceId: preference }} 
                  customization={{ texts: { action: 'pay', valueProp: 'smart_option' } }}
                />
              )}
            </div>
          </div>
        </div>
      ) : consultaSeleccionada === 'consultaPlus4' && !statusMP ? (
        <div className="container-consulta-content">
          <h1 className="ccc-title">Análisis Nutricional del Test Nutrigenético + Plan Nutricional Personalizado + 2 Controles</h1>
          <div className="analysis-plus-container">
            <div className="image-container">
              <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906806/mistergen/landing-nutritionists-image_ltu9y3.png" alt="Consulta nutricional" />
              {turnosLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <CircularProgress />
                </div>
              ) : (
                <TurnosList turnos={turnos} />
              )}
            </div>
            <div className="content-container">
              <p></p>
              <p><strong>Incluye 4 consultas:</strong></p>
              <ul>
                <li><b className="pink-color">- Lectura y análisis del test nutrigenético.</b></li>
                <li>- Consulta nutricional virtual de 30 minutos.</li>
                <li><b className="pink-color">- Entrevista personal, registro de datos para el armado del plan nutricional.</b></li>
                <li>- Consulta virtual o presencial de 45 minutos.</li>
                <li><b className="pink-color">- Se realizarán 2 controles adicionales de revisión de objetivos y ajustes del plan nutricional.</b></li>
                <li>- Consulta virtual o presencial de 30 minutos.</li>
              </ul>
              <div className="price-container">
                <p className="price-total">Precio total</p>
                <p className="price-amount">$U 7.590 <span className="tax-included">Impuestos incluidos</span></p>
                <p className="installments">o hasta 6 cuotas de $U 1.265</p>              
              </div>
              {!preference ? (
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="large" 
                  style={{ margin: '0px 40px', width: '100%' }}
                  onClick={handleCheckout}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Contratar"}
                </Button>
              ) : (
                <Wallet 
                  initialization={{ preferenceId: preference }} 
                  customization={{ texts: { action: 'pay', valueProp: 'smart_option' } }}
                />
              )}
            </div>
          </div>
        </div>
      ) : consultaSeleccionada === 'consultaPlus8' && !statusMP ? (
        <div className="container-consulta-content">
          <h1 className="ccc-title">Análisis Nutricional del Test Nutrigenético + Plan Nutricional  Personalizado + 6 controles</h1>
          <div className="analysis-plus-container">
            <div className="image-container">
              <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906806/mistergen/landing-nutritionists-image_ltu9y3.png" alt="Consulta nutricional" />
              {turnosLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <CircularProgress />
                </div>
              ) : (
                <TurnosList turnos={turnos} />
              )}
            </div>
            <div className="content-container">
              <p></p>
              <p><strong>Incluye 8 consultas:</strong></p>
              <ul>
                <li><b className="pink-color">- Lectura y análisis del test nutrigenético.</b></li>
                <li>- Consulta nutricional virtual de 30 minutos.</li>
                <li><b className="pink-color">- Entrevista personal, registro de datos para el armado del plan nutricional.</b></li>
                <li>- Consulta virtual o presencial de 45 minutos.</li>
                <li><b className="pink-color">- Se realizarán 6 controles adicionales de revisión de objetivos y ajustes del plan nutricional.</b></li>
                <li>- Consulta virtual o presencial de 30 minutos.</li>
              </ul>
              <div className="price-container">
                <p className="price-total">Precio total</p>
                <p className="price-amount">$U 12.900 <span className="tax-included">Impuestos incluidos</span></p>
                <p className="installments">o hasta 6 cuotas de $U 2.150</p>
              </div>
              {!preference ? (
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="large" 
                  style={{ margin: '0px 40px', width: '100%' }}
                  onClick={handleCheckout}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Contratar"}
                </Button>
              ) : (
                <Wallet 
                  initialization={{ preferenceId: preference }} 
                  customization={{ texts: { action: 'pay', valueProp: 'smart_option' } }}
                />
              )}
            </div>
          </div>
        </div>
      ) : consultaSeleccionada === 'controlesx2' && !statusMP ? (
        <div className="container-consulta-content">
          <h1 className="ccc-title">2 controles de seguimiento nutricional</h1>
          <div className="analysis-plus-container">
            <div className="image-container">
              <img src="https://res.cloudinary.com/hqs-cdn/image/upload/v1634906806/mistergen/landing-nutritionists-image_ltu9y3.png" alt="Consulta nutricional" />
              {turnosLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <CircularProgress />
                </div>
              ) : (
                <TurnosList turnos={turnos} />
              )}
            </div>
            <div className="content-container">
              <p></p>
              <p><b>Incluye:</b></p>
              <ul>
                <li><b className="pink-color">- Se realizarán 2 controles de revisión de objetivos y ajustes del plan nutricional.</b></li>
                <li>- Consulta virtual o presencial de 30 minutos.</li>
                <li><b className="pink-color">- Válido para clientes que hayan contratado previamente consulta inicial y plan nutricional.</b></li>
              </ul>
              <div className="price-container">
                <p className="price-total">Precio total</p>
                <p className="price-amount">$U 2.860 <span className="tax-included">Impuestos incluidos</span></p>
              </div>
              {!preference ? (
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="large" 
                  style={{ margin: '0px 40px', width: '100%' }}
                  onClick={handleCheckout}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Contratar"}
                </Button>
              ) : (
                <Wallet 
                  initialization={{ preferenceId: preference }} 
                  customization={{ texts: { action: 'pay', valueProp: 'smart_option' } }}
                />
              )}
            </div>
          </div>
        </div>
      ) : null}
        
      {/* Popup para usuarios no logueados */}
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
        <DialogTitle>Ingresa tus datos</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Apellido"
            fullWidth
            value={formData.lastName}
            onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Teléfono"
            fullWidth
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPopup(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handlePopupSubmit} color="primary">
            Continuar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConsultaNutricional;
